import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiClaude,
  SiIntellijidea,
  SiJira,
  SiXcode,
} from "react-icons/si";

import { VscVscode } from "react-icons/vsc";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={6} md={3} xl={2} >
        <VscVscode className="tech-iconsPic"/>
        <p>VS Code</p>
      </Col>
      <Col xs={6} md={3} xl={2} >
        <SiClaude className="tech-iconsPic"/>
        <p>Claude</p>
      </Col>
      <Col xs={6} md={3} xl={2} >
        <SiIntellijidea className="tech-iconsPic"/>
        <p>IntelliJ IDEA</p>
      </Col>
      <Col xs={6} md={3} xl={2} >
        <SiXcode className="tech-iconsPic"/>
        <p>Xcode</p>
      </Col>
      <Col xs={6} md={3} xl={2} >
        <SiJira className="tech-iconsPic"/>
        <p>Jira</p>
      </Col>
    </Row>
  );
}

export default Toolstack;
